import React, { PropTypes } from 'react';

import style from './style.scss';

const PhotoBanner = (props) => {

    return (
        <div className={style.photoBanner}>
            <div className={style.bananas}>

            </div>
            <div className={style.oatmealBananas}>

            </div>
            <div className={style.bigRiceSalad}>

            </div>

        </div>
    );
}

export default PhotoBanner;




/** WEBPACK FOOTER **
 ** ./app/components/photoBanner/PhotoBanner.js
 **/